<template>
  <v-card class="elevation-2 pa-4 ma-4" :loading="processing">
    <v-card-title>{{ $t('Сведения об организации') }}</v-card-title>
    <v-form ref="form" :readonly="!editing">
      <Input
        ref="contragentFullNameRef"
        label="Наименование организации"
        v-model="contragent.fullName"
        :rules="rules.fullName"
        :disabled="processing"
        :validate-on="!editing ? 'blur' : undefined"
        :class="{ 'disabled': !editing}"
        :required="editing"
      />
      <Input
        ref="contragentInnRef"
        label="CRN"
        v-model="contragent.inn"
        v-mask="masks.inn"
        :rules="rules.crn"
        :disabled="processing"
        :validate-on="!editing ? 'blur' : undefined"
        :class="{ 'disabled': !editing}"
        :required="editing"
      />
      <Input
        ref="contragentPhoneRef"
        label="Телефон"
        v-model="contragent.phone"
        :rules="rules.phone"
        maxlength="255"
        :disabled="processing"
        :validate-on="!editing ? 'blur' : undefined"
        :class="{ 'disabled': !editing}"
      />
      <Input
        label="Адрес электронной почты"
        ref="contragentEmailRef"
        v-model="contragent.email"
        :rules="rules.email"
        :disabled="processing"
        :validate-on="!editing ? 'blur' : undefined"
        :class="{ 'disabled': !editing}"
      />
      <v-radio-group
        v-model="contragent.type"
      >
        <v-radio :label="$t('Является организатором')" :value="ORGANIZER" />
        <v-radio :label="$t('Является участником')" :value="SUPPLIER" />
      </v-radio-group>
    </v-form>
    <v-card-actions style="float: right">
      <v-btn
        color="primary"
        density="comfortable"
        variant="outlined"
        @click="cancelAction()"
        :disabled="processing"
      >{{ $t('Назад') }}</v-btn>
      <v-btn
        v-if="!editing && !btnHidden"
        color="primary"
        density="comfortable"
        variant="elevated"
        @click="editAction()"
        :disabled="processing"
      >{{ $t('Редактировать') }}</v-btn>
      <v-btn
        v-else-if="editing && !btnHidden"
        color="primary"
        density="comfortable"
        variant="elevated"
        @click="saveAction()"
        :disabled="processing"
      >{{ $t('Сохранить') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import api from '@/api';
import { toast } from '@/lib/toast';
import { useEditContragent } from "@/lib/composable";
import Input from "@intec/vue-components/form/Input.vue";
import { useDialogStore } from '@/stores/dialog';

export default {
  name: 'Contragent',
  components: {Input},
  setup() {
    const { SUPPLIER, ORGANIZER, contragent, rules, masks, fillContragentData, contragentInnRef } = useEditContragent();
    const dialogStore = useDialogStore()
    return { SUPPLIER, ORGANIZER, contragent, rules, masks, fillContragentData, contragentInnRef, dialogStore };
  },
  data() {
    let contragentId = this.$route.params['id'];
    return {
      editing: contragentId == null,
      btnHidden: false,
      processing: false,
      contragentId: contragentId,
    };
  },
  methods: {
    async loadContragentInfo(contragentId) {
      this.processing = true;
      let contragent = await api.get(`/admin/contragents/${contragentId}/load`);
      this.fillContragentData(contragent);
      this.processing = false;
    },
    async save() {
      let validator = await this.$refs.form.validate()
      if (!validator.valid) {
        toast.error('Проверьте правильность заполнения формы');
        return false;
      }

      let data = this.fillContragentData();
      let contragentId = data.id;

      let formData = new FormData();
      formData.append('data', JSON.stringify(data));
      if (contragentId) {
        await api.post(`/admin/contragents/${contragentId}/save`, formData);
      } else {
        let response = await api.post(`/admin/contragents/create`, formData);
        this.contragent.id = response.id;
        this.$router.replace({
          name: 'admin.contragents.view',
          params: { id: this.contragent.id },
        });
      }
      return true;
    },
    editAction() {
      this.editing = true;
      this.$refs.form.validate();
    },
    async saveAction() {
      this.processing = true;
      try {
        let result = await this.save();
        if (result) {
          toast.info('Сведения об организации успешно сохранены');
          history.back();
        }
      } catch (e) {
        toast.error(e.message);
      }
      this.processing = false;
    },
    cancelAction() {
      history.back();
    },
  },
  async mounted() {
    if (this.contragentId) {
      this.editing = this.$route.path.includes('edit');
      this.btnHidden = this.$route.path.includes('view');

      await this.loadContragentInfo(this.contragentId);
    }
  },
  watch: {
    $route(toRoute) {
      this.contragentId = toRoute.params['id'];
    },
  },
};
</script>
